<template>
  <div>
    <b-button class="typo-butt-command mr-1 ml-1 mt-3 but-oval" @click="openCreateSceneModal">
      <i class="fas fa-1x fa-cloud-moon mr-2"></i>
      {{$t("scene.button_title")}}
    </b-button>

    <!-- Create Scene Modal-->
    <b-modal
      :hide-footer="footer_hide"
      ok-only
      ref="modal"
      :id="'modal-create-scene'+this._uid"
      :title="$t('scene.modal_title')"
      :ok-title="$t('scene.button_salva')"
      :cancel-title="$t('scene.button_cancel')"
      @ok="handleOk"
    >
    
    <!-- Nome scena -->
    <b-form-group>
        <label for="label-scene-name" class="typo-label">{{$t("scene.input_label")}}</label>
            <b-form-input 
               class="input-line-blue"
                v-model="sceneName" 
                type="text" 
                :state="validation_sceneName">
            </b-form-input>
            <b-form-invalid-feedback
                :state="validation_sceneName"
            >{{$t("edit_plant_modal.validation_null")}}</b-form-invalid-feedback>
      </b-form-group>

    <!-- Accensione ON-OFF -->
      <div class="p-4 text-center">

      <toggle-switch
              :options="switchOnOff"
              v-model="onoff_switch"
              @change="changeSwitch($event.value)"
            />
      
      </div>

      <div class="p-4 text-center typo-color-label">Dimming</div>

      <div style="padding-left:115px">

     <!-- Dimming -->
      <round-slider
        v-model="sliderValue"
        start-angle="315"
        end-angle="+270"
        line-cap="round"
        radius="120"
        rangeColor="#009DE0"
        pathColor="#F4F4F4"
      />

      </div>
      
    </b-modal>
  </div>
</template>

<script>
import RoundSlider from 'vue-round-slider';

export default {
  name: "createScene",
  components: {
    RoundSlider,
  },
  data() {
    return {
          switchOnOff: {
          layout: {
            color: '#009DE0',
            backgroundColor: 'white',
            selectedColor: 'white',
            selectedBackgroundColor: 'blue',
            borderColor: 'whitesmoke',
            fontFamily: 'Roboto',
            fontWeight: 'normal',
            fontWeightSelected: 'bold',
            squareCorners: false,
            noBorder: false
          },
          size: {
            fontSize: 1.2,
            height: 2.8,
            padding: 0.5,
            width: 10
          },
          items: {
            delay: .4,
            preSelected: '',
            disabled: false,
            labels: [
              {name: 'OFF', color: 'white', backgroundColor: ' #009DE0'},
              {name: 'ON', color: 'white', backgroundColor: ' #009DE0'}
            ]
          },
      },
      onoff_switch:"",
      sliderValue: 50,
      footer_hide: false,
      saveButton: false,
      sceneName:""
    };
  },
  computed:{
    validation_sceneName() {
      if (this.saveButton == true) return this.sceneName.length > 0;
    }
  },
  methods: {
    changeSwitch(){
      console.log("Change switch: ", this.onoff_switch);
      if(this.onoff_switch=="OFF")
        this.sliderValue=0;
      if(this.onoff_switch=="ON")
        this.sliderValue=100;  
    },
    openCreateSceneModal() {
      this.saveButton=false;
      this.sliderValue=50;
      this.onoff_switch="";
      this.sceneName="";
      this.$bvModal.show('modal-create-scene'+this._uid);
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      this.saveButton=true;
      this.saveScene();
    },
    saveScene() {
      if(this.validation_sceneName)
      {
      
        console.log("TODO: Salva scena in DB");
      
        // Hide the modal manually
        this.$nextTick(() => {
          this.$refs.modal.hide();
        });
      }
    }
  }
};
</script>
